<template>
    <v-list>
        <v-subheader v-if="!drawer">
            <div class="d-flex flex-row align-baseline">
                <router-link
                    to="/"
                    class="text-decoration-none text-sm-h5 white--text mb-2"
                >
                    #IAM<span class="text--theme-accent">BOSS</span>
                </router-link>
                <ShowChangelog />
            </div>
        </v-subheader>

        <template v-for="item in items">
            <navigation-item
                v-if="!item.items"
                :key="item.title"
                :item="item"
            />
            <navigation-group
                v-if="item.items"
                :key="item.title"
                :item="item"
            />
        </template>
    </v-list>
</template>

<script>
import NavigationItem from "@/components/Layout/Partials/NavigationItem";
import NavigationGroup from "@/components/Layout/Partials/NavigationGroup";
import ShowChangelog from "@/components/Changelog/index";

export default {
    components: { NavigationGroup, NavigationItem, ShowChangelog },
    props: {
        drawer: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getActive(items = []) {
            return items.find((item) => {
                if (this.getActive(item.items)) {
                    item.active = true;

                    return true;
                }

                if (item.to === this.$route.path) {
                    item.active = true;

                    return true;
                }

                if (
                    this.$route.meta.activates &&
                    item.to === this.$route.meta.activates
                ) {
                    item.active = true;

                    return true;
                }
            });
        },
    },
    created() {
        this.getActive(this.items);
    },
    data() {
        return {
            items: [
                {
                    to: "/",
                    icon: "mdi-home",
                    title: "Dashboard",
                },
                {
                    icon: "mdi-account-group",
                    title: "Klanten",
                    items: [
                        {
                            to: "/customer",
                            title: "Overzicht",
                            permission: "customers",
                        },
                        {
                            to: "/dossier/complaint",
                            title: "Klachten",
                            permission: "complaints",
                        },
                        {
                            to: "/dossier/traveller/out-of-sync",
                            title: "Oude Versie Reizigers",
                            permission: "customers.dossiers",
                        },
                        {
                            to: "/customer/dialogue",
                            title: "Klantenservice",
                            permission: "customers.dialogues",
                        },
                        {
                            to: "/dossier/survey",
                            title: "Surveys",
                            permission: "customers.dossier-surveys",
                        },
                        {
                            to: "/magazine",
                            title: "Magazine export",
                            permission: "customers.magazine-requests",
                        },
                        {
                            to: "/online-magazine",
                            title: "Online magazines",
                            permission: "customers.online-magazine",
                        },
                        {
                            to: "/contact-request",
                            title: "Contact aanvragen",
                            permission: "customers.contact-requests",
                        },
                        {
                            to: "/download",
                            title: "Downloads",
                            permission: "downloads",
                        },
                        {
                            to: "/customer/travel-miles/manual-addition",
                            title: "Travelmiles toevoegingen",
                            permission: "travelmiles.manual-additions",
                        },
                        {
                            title: "Instellingen",
                            items: [
                                {
                                    title: "Taken types",
                                    to: "/task/action",
                                    permission: "tasks.actions",
                                },
                                {
                                    title: "Kent ons van",
                                    to: "/customer/marketing-channel",
                                    permission: "customers.marketing-channels",
                                },
                                {
                                    title: "Tags",
                                    to: "/customer/tag",
                                    permission: "customers.tags",
                                },
                                {
                                    title: "Presentjes",
                                    to: "/present",
                                    permission: "presents",
                                },
                                {
                                    title: "Veelgestelde vragen",
                                    to: "/faq-item",
                                    permission: "faq-items",
                                },
                                {
                                    title: "Hubby pakketten",
                                    to: "/hubby/country-package-size",
                                    permission: "hubby.country-package-sizes",
                                },
                            ],
                        },
                    ],
                },
                {
                    to: "/scrumboard",
                    title: "Conversie Board",
                    permission: "users.scrumboard",
                    icon: "mdi-view-dashboard-variant",
                },
                {
                    to: "/backoffice-scrumboard",
                    title: "Backoffice Board",
                    permission: "users.scrumboard",
                    icon: "mdi-view-dashboard-outline",
                },
                {
                    icon: "mdi-folder-arrow-up",
                    title: "Beeldbank",
                    to: "/media-library",
                    permission: "website.media-library",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/media-library",
                            permission: "website.media-library",
                        },
                        {
                            title: "Tags",
                            to: "/media-library/tag",
                            permission: "website.media-library.tags",
                        },
                    ],
                },
                {
                    icon: "mdi-sitemap",
                    title: "Website",
                    items: [
                        {
                            title: "Navigatie",
                            to: "/website-navigations",
                            permission: "website.navigations",
                        },
                        {
                            title: "Footer",
                            to: "/website-footer",
                            permission: "website.navigations",
                        },
                        {
                            title: "Custom pagina's",
                            to: "/website-pages",
                            permission: "website.pages",
                        },
                        {
                            title: "Product filter pagina's",
                            to: "/website-filter-pages",
                            permission: "website.filter-pages",
                        },
                        {
                            title: "Widgets",
                            to: "/website-widgets",
                            permission: "website.widgets",
                        },
                        {
                            title: "Blog",
                            to: "/website-blogs",
                            permission: "website.blogs",
                        },
                        {
                            title: "Nieuws",
                            to: "/website-news",
                            permission: "website.news",
                        },
                        {
                            title: "Klanten reviews",
                            to: "/website-customer-reviews",
                            permission: "website.customer-reviews",
                        },
                        {
                            title: "Medewerkers land expertise",
                            to: "/user/expertise-country",
                            permission: "website.user-country-expertises",
                        },
                        {
                            title: "Website categorieën",
                            to: "/website/categories",
                            permission: "website.categories",
                        },
                        {
                            title: "Land informatie",
                            to: "/website/country",
                            permission: "website.countries",
                        },
                        {
                            title: "Website tags",
                            to: "/website-product-tags",
                            permission: "website.tags",
                        },
                        {
                            title: "Wettelijke content",
                            to: "/legal-content",
                            permission: "website.legal-contents",
                        },
                        {
                            title: "Alle URL's",
                            to: "/website/routes",
                            permission: "website.routes",
                        },
                        {
                            title: "Redirects",
                            to: "/website/redirect",
                            permission: "website.redirects",
                        },
                        {
                            title: "Cache",
                            to: "/website/cache",
                            permission: "website.cache",
                        },
                        {
                            title: "Aanbod sorteren",
                            to: "/website/product-sort",
                            permission: "website.filter-pages",
                        },
                    ],
                },
                {
                    icon: "mdi-sitemap",
                    title: "Platinum",
                    items: [
                        {
                            title: "Navigatie",
                            to: "/platinum/navigations",
                            permission: "website.navigations",
                        },
                        {
                            title: "Footer links",
                            to: "/platinum/footer-links",
                            permission: "website.navigations",
                        },
                        {
                            title: "Pagina's",
                            to: "/platinum/pages",
                            permission: "website.pages",
                        },
                        {
                            title: "Hotels",
                            to: "/platinum/hotel",
                            permission: "website.pages",
                        },
                        {
                            title: "Experiences",
                            to: "/platinum/experience",
                            permission: "website.pages",
                        },
                        {
                            title: "Alle URL's",
                            to: "/platinum/routes",
                            permission: "website.routes",
                        },
                        {
                            title: "Redirects",
                            to: "/platinum/redirect",
                            permission: "website.redirects",
                        },
                        {
                            title: "Widgets",
                            to: "/platinum-widgets",
                            permission: "website.widgets",
                        },
                        {
                            title: "Cache",
                            to: "/platinum/cache",
                            permission: "website.cache",
                        },
                    ],
                },
                {
                    to: "/dossiers/no-users",
                    title: "Zonder Medewerker",
                    permission: "customers.dossiers.without-user",
                    icon: "mdi-account-question",
                },
                {
                    icon: "mdi-thermometer",
                    title: "Leads",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/dossiers/leads/general",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Geannuleerd",
                            to: "/dossiers/leads/cancelled",
                            permission: "customers.dossiers",
                        },
                    ],
                },
                {
                    icon: "mdi-view-list",
                    title: "Offertes",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/proposals/offers/general",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Marge Controle",
                            to: "/proposals/offers/margin-check",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Product Controle",
                            to: "/proposals/offers/order-check",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Iata Controle",
                            to: "/proposals/offers/iata-check",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Controle afronden",
                            to: "/proposals/offers/finish-check",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Geweigerd",
                            to: "/proposals/offers/refused",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Niet in aanvraag",
                            to: "/proposals/offers/not-requested",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "In aanvraag",
                            to: "/proposals/offers/requested",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Alles akkoord",
                            to: "/proposals/offers/to-accepted",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Geannuleerde Offertes",
                            to: "/proposals/offers/cancelled",
                            permission: "customers.dossiers",
                        },
                    ],
                },
                {
                    icon: "mdi-thumb-up",
                    title: "Boekingen",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/proposals/bookings/general",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Geannuleerde Boekingen",
                            to: "/proposals/bookings/cancelled",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Boekingslijst",
                            to: "/proposals/bookings/list",
                            permission: "customers.dossiers.calamities",
                        },
                        {
                            title: "Reisbescheiden",
                            to: "/proposals/bookings/travel-documents",
                            permission: "customers.dossiers",
                        },
                        {
                            title: "Vertrekkende boekingen",
                            to: "/proposals/bookings/departures",
                            permission: "customers.dossiers",
                        },
                    ],
                },
                {
                    icon: "mdi-alpha-p-circle",
                    title: "Producten",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/product",
                            permission: "products",
                        },
                        {
                            title: "Extern",
                            to: "/agent/inventory",
                            permission: "products",
                        },
                        {
                            title: "Externe product types",
                            to: "/agent/default-margin",
                            permission: "products",
                        },
                        {
                            title: "Inactief",
                            to: "/product/relation",
                            permission: "products.inactive-product-relations",
                        },
                        {
                            title: "Agenten",
                            to: "/agent",
                            permission: "products.agents",
                        },
                        {
                            title: "Prijs doortrekken",
                            to: "/product/price-extension",
                            permission: "products",
                        },
                        {
                            title: "Reisvoorstel teksten",
                            to: "/presentation/placeholder",
                            permission: "products",
                        },
                        {
                            title: "Land notities",
                            to: "/country/notice",
                            permission: "products",
                        },
                        {
                            title: "Website Highlight",
                            to: "/website-highlight",
                            permission: "products",
                        },
                        {
                            title: "Dag tot dag sjablonen",
                            to: "/presentation/day/prefill",
                            permission: "products",
                        },
                    ],
                },
                {
                    icon: "mdi-airplane",
                    title: "Vluchten",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/flight",
                            permission: "flights",
                        },
                        {
                            title: "Vlucht klassen",
                            to: "/flight/classification",
                            permission: "flights.classifications",
                        },
                        {
                            title: "IATA Print kalender",
                            to: "/ticket/calender",
                            permission:
                                "customers.dossiers.proposals.print-calender",
                        },
                        {
                            title: "Dossier tickets",
                            to: "/dossiers/ticket",
                            permission: "tickets",
                        },
                        {
                            title: "Dossier ticket klassen",
                            to: "/dossiers/ticket/flight/classification",
                            permission: "tickets.classifications",
                        },
                        {
                            title: "Vliegmaatschappijen",
                            to: "/airline",
                            permission: "airlines",
                        },
                        {
                            title: "Allotments",
                            to: "/airline/allotment",
                            permission: "airlines.allotments",
                        },
                    ],
                },
                {
                    icon: "mdi-currency-eur",
                    title: "Financieel",
                    items: [
                        {
                            title: "Valuta",
                            to: "/currencies",
                            permission: "exchange-rate",
                        },
                        {
                            title: "Margelijsten",
                            to: "/margin",
                            permission: "margin",
                        },
                        {
                            title: "Betalingsachterstanden",
                            to: "/proposal/payment-term/overdue",
                            permission:
                                "customers.dossiers.proposals.overdue-payment-terms",
                        },
                        {
                            title: "Openstaande posten",
                            to: "/proposals/open-payments",
                            permission:
                                "customers.dossiers.proposals.open-payments",
                        },
                        {
                            title: "Afdelingsomzet",
                            to: "/statistics/revenue/group",
                            permission: "statistics.user-groups",
                        },
                        {
                            title: "User Targets",
                            to: "/user/sale-target",
                            permission: "users.sale-targets",
                        },
                        {
                            title: "Airline Targets",
                            to: "/airline/target",
                            permission: "airlines.targets",
                        },
                        {
                            title: "Marge instellingen",
                            to: "/minimum-margin",
                            permission: "minimum-margin",
                        },
                        {
                            title: "Factuur teksten",
                            to: "/proposal/invoice/remark",
                            permission: "invoice-remarks",
                        },
                        {
                            title: "Instellingen",
                            to: "/settings/financial",
                            permission: "settings",
                        },
                    ],
                },
                {
                    icon: "mdi-map-marker",
                    title: "Locaties",
                    items: [
                        {
                            title: "Landen",
                            to: "/country",
                            permission: "countries",
                        },
                        {
                            title: "Steden",
                            to: "/city",
                            permission: "cities",
                        },
                        {
                            title: "Vliegvelden",
                            to: "/airport",
                            permission: "airports",
                        },
                        {
                            title: "Regio's",
                            to: "/region",
                            permission: "regions",
                        },
                    ],
                },
                {
                    icon: "mdi-chart-box",
                    title: "Rapportage",
                    items: [
                        {
                            title: "Sales",
                            items: [
                                {
                                    title: "Status Medewerkers",
                                    to: "/statistics/sales/status/users",
                                    permission: "statistics.users",
                                },
                                {
                                    title: "Conversie",
                                    to: "/statistics/sales/conversion",
                                    permission: "statistics.users",
                                },
                                {
                                    title: "Klant akkoord",
                                    to: "/statistics/sales/customer_accept",
                                    permission: "statistics.users",
                                },
                            ],
                        },
                        {
                            title: "Product",
                            items: [
                                {
                                    title: "Aantal verkochte producten",
                                    to: "/statistics/product/sold",
                                    permission: "statistics.products",
                                },
                            ],
                        },
                        {
                            title: 'TravelMiles',
                            items: [
                                {
                                    title: "Transacties",
                                    to: "/statistics/travelmiles",
                                    permission: "travelmiles",
                                },
                                {
                                    title: 'Klanten',
                                    to: '/statistics/travelmiles/customers',
                                    permission: "travelmiles",
                                }
                            ],
                        },
                        {
                            title: "Export Financieel",
                            to: "/statistics/financial",
                            permission: "statistics.financial",
                        },
                        {
                            title: "Gespreksgeschiedenis",
                            to: "/phone-call",
                        },
                        {
                            title: "Sms geschiedenis",
                            to: "/phone-sms",
                        },
                        {
                            title: "Leads",
                            items: [
                                {
                                    title: "Export",
                                    to: "/statistics/leads",
                                    permission: "customers.dossiers",
                                },
                                {
                                    title: "Grafiek",
                                    to: "/dossiers/leads/visual",
                                    permission: "customers.dossiers",
                                },
                            ],
                        },
                        {
                            title: "Werkplekregistratie",
                            to: "/user/work-location/summary",
                            permission: "statistics.users",
                        },
                    ],
                },
                {
                    icon: "mdi-broadcast",
                    title: "Campagnes",
                    to: "/campaign",
                    permission: "marketing",
                },
                {
                    icon: "mdi-account",
                    title: "Gebruikers",
                    items: [
                        {
                            title: "Overzicht",
                            to: "/users",
                            permission: "users",
                        },
                        {
                            title: "Rollen",
                            to: "/user/role",
                            permission: "users.roles",
                        },
                        {
                            title: "Afdelingen",
                            to: "/user/group",
                            permission: "users.groups",
                        },
                        {
                            title: "Omzet groepen",
                            to: "/revenue-group",
                            permission: "users.revenue-groups",
                        },
                        {
                            title: "Meldingen",
                            to: "/user/notification",
                            permission: "users.notifications",
                        },
                        {
                            title: "Interne help teksten",
                            to: "/internal-help-text",
                            permission: "users.notifications",
                        },
                        {
                            to: "/pageViews",
                            title: "Bekeken pagina's",
                        },
                        {
                            to: "/agenda",
                            title: "Agenda",
                        },
                        {
                            to: "/user/country-proficiency",
                            title: "Landexpertise"
                        },
                        {
                            to: '/user/journey',
                            title: 'Vakanties',
                        }
                    ],
                },
                {
                    icon: "mdi-cog",
                    title: "Instellingen",
                    items: [
                        {
                            title: "AI Prompts",
                            to: "/settings/ai-prompt",
                            permission: "general-settings.ai-prompts",
                        },
                    ],
                },
            ],
        };
    },
};
</script>
